import React, { useState } from 'react';
import styled from 'styled-components';
import { Button } from '../Button';
import { ChevronDownIcon, ChevronUpIcon } from '../Icons';
import { TableCell, TableRow } from '.';
export const ExpandableTableRow = ({ rowData, keysToRender, expandableContent, ariaId, isDisabled = false, isExpanded: controlledIsExpanded, onToggle, }) => {
    const [internalIsExpanded, setInternalIsExpanded] = useState(false);
    // Use controlled state if provided, otherwise use internal state
    const isExpanded = controlledIsExpanded !== undefined ? controlledIsExpanded : internalIsExpanded;
    const isControlled = controlledIsExpanded !== undefined;
    const handleToggle = () => {
        if (isControlled && onToggle) {
            onToggle();
        }
        else if (!isControlled) {
            setInternalIsExpanded(!internalIsExpanded);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(TableRow, { "$noBorder": isExpanded },
            React.createElement(StyledTableCell, { "aria-expanded": isExpanded },
                React.createElement(StyledButton, { variant: "tertiary", onClick: handleToggle, iconOnly: isExpanded ? React.createElement(ChevronUpIcon, null) : React.createElement(ChevronDownIcon, null), iconOnlyAltText: "Toggle row", isDisabled: isDisabled })),
            keysToRender.map((key) => (React.createElement(TableCell, { key: `${key}-${rowData[key]}` }, rowData[key])))),
        isExpanded && (React.createElement(TableRow, { id: ariaId, "aria-label": "More Information" },
            React.createElement(TableCell, { colSpan: keysToRender.length + 1 }, expandableContent)))));
};
const StyledTableCell = styled(TableCell) `
  padding: 1.6rem 0;
`;
const StyledButton = styled(Button) `
  background: none !important;
  > svg {
    fill: ${({ theme }) => theme.colors.dark};
  }
  &:hover {
    box-shadow: none !important;
  }
`;
